<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Tactical Devices" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading {{ page_title }}
                        .header-cta
                        router-link.btn-default(to="/tactical-devices") Back
            .box__body
                .container-form
                    //- section Territory spesifict
                    section.group-fields.border-b
                        //- name
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2() Device Name *
                            .field__form
                                input.field-style(type="text" placeholder="Device Name" v-model="name" maxlength="255")
                                .error(v-if="error_name !== null") {{ error_name }}
                        
                        //- case name
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2() Device ID (IMEI) *
                            .field__form
                                input.field-style(type="text" placeholder="Device ID (IMEI)" v-model="device_id"  maxlength="255" @keydown.space.prevent)
                                .error(v-if="error_device_id !== null") {{ error_device_id }}
                        
                        //- case name
                        //- .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2() MSISDN
                            .field__form
                                input.field-style(type="text" placeholder="Write MSISDN Name")

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2() Description
                            .field__form
                                textarea.field-style(id="description" name="description" placeholder="Description" v-model="description" style="min-height: 200px;")
                                .error(v-if="error_description !== null") {{ error_description }}
                        
                    //-===== end section
                        
                    //- section territory target
                    section.group-fields.border-b.mb-12.pb-8
                        //- name
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2.pt-2() User
                            .field__form
                                .relative.field--search.w-full
                                    input.field-style#find-user-input(type="text" placeholder="Search user here (write min 3 characters)" v-model="users_keyword" @keyup="searchUsers()")
                                    .absolute.inset-y-0.right-0.flex.items-center.px-2(v-if="Object.keys(user_selected).length == 0")
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                    .field-style.absolute.w-full.h-full.flex.items-center.justify-between.px-3.rounded.top-0(v-else)
                                        .flex.items-center
                                            figure.w-6.h-6.mr-4
                                                img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="ImgAvatar")
                                            span.text-light.name-index {{ user_selected.name ? user_selected.name : '' }}
                                        button(v-if="user_selected.name" @click="setEmptyUser" v-tooltip="'Remove user'")
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>

                                template(v-if="error_user !== null")
                                    .flex.items-center
                                        .error {{ error_user }}
                                        
                                .flex.items-center.w-full.mb-4.mt-4.justify-center(v-if="load_data_status_users_tactical_list === 'loading'")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")

                                template(v-else-if="users_tactical_list.data && users_tactical_list.data.length > 0")
                                    .flex.items-center.w-full.mb-2.mt-4
                                        span.text-xs.uppercase.text-light.font-bold Choose a User
                                    .flex.items-center.w-full.mb-4
                                    .target-lists.block.w-full
                                        ul
                                            li.flex.items-center.justify-between.border-b.p-4(
                                                style="cursor: pointer;"
                                                v-tooltip="'Choose this user'"
                                                v-for="(user,index) in users_tactical_list.data"
                                                :key="user.id"
                                                @click="chooseUser(user)"
                                            )
                                                div.flex.items-center
                                                    figure.w-6.h-6.mr-4
                                                        img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="ImgAvatar")
                                                    span.text-light.name-index {{ user.name }}

                                template(v-else-if="users_tactical_list.data && users_tactical_list.data.length == 0")
                                    span No data available.
                    //-===== end section
                    .flex.items-center.justify-end.mb-8
                        //- button.btn-primary-o.mr-3 DRAFT
                        //- button.btn-primary SAVE

                        .flex.items-center.justify-end
                        button.ml-2.btn-default.btn-large(type='button' @click="reset()")
                            | Reset
                        button.ml-2.btn-primary-o.btn-large(type='submit' @click="submit($event, true)")
                            | Save &amp; Continue
                        button.ml-2.btn-primary.btn-large(type='submit' @click="submit")
                            | Save

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from './../../components/HeaderGlobal.vue';
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'TacticalDevicesForm',
    components: {
        HeaderGlobal,
        Spinner,
    },
    data: function() {
        return {
            name: '',
            device_id: '',
            user: '',
            description: '',

            // error field
            error_name: '',
            error_device_id: '',
            error_user: '',
            error_description: '',

            users_keyword: '',
            user_selected: {},

            // ImgAvatar: 'https://randomuser.me/api/portraits/men/9.jpg',
            ImgAvatar: require('../../assets/images/default-avatar.png'),
        }
    },
    computed: {
        ...mapState([
            'load_data_status_tactical_devices_detail',
            'load_data_status_users_tactical_list',
            'tactical_devices_detail',
            'users_tactical_list',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        breadcrumb() {
            let page = {
                name: 'Edit Tactical Device',
                url: '/tactical-devices/'+this.id+'/edit',
            };
            if (this.route_name === 'PageTacticalDevicesCreate') {
                page = {
                    name: 'Add Tactical Device',
                    url: '/tactical-devices/create',
                };
            }

            return [
                {
                    name: 'Tactical Devices',
                    url: '/tactical-devices',
                },
                page,
            ];
        },
        page_title() {
            let title = 'Edit Tactical Device';
            if (this.route_name === 'PageTacticalDevicesCreate')
                title = 'Add Tactical Device';
            return title;
        },
    },
    watch: {
        route_name() {
            this.getData();
        },
        id() {},
        breadcrumb() {},
        page_title() {},
        users_keyword(newData) {
            if (newData.length < 3)
                this.$store.commit('setUsersTacticalList', {});
        },
        tactical_devices_detail(newData) {
            this.name = (newData.name ? newData.name : '');
            this.device_id = (newData.device_id ? newData.device_id : '');
            this.description = (newData.description ? newData.description : '');
            // this.user = (newData.users && newData.users[0] ? newData.users[0].id : '');
            if (newData.users && newData.users[0]) {
                this.user_selected = newData.users[0];
                this.user = newData.users[0].id;
            } else {
                this.user_selected = {};
                this.user = '';
            }
        },
        name() {},
        device_id() {},
        user() {},
        description() {},
    },
    methods: {
        changeImgAvatar(e) {
            const file = e.target.files[0];
            this.ImgAvatar = URL.createObjectURL(file);
        },
        searchUsers() {
                // clear timeout variable
                clearTimeout(this.timeout);

                var self = this;
                this.timeout = setTimeout(function () {
                    if (self.users_keyword.length > 2) {
                        self.$store.commit('setUsersTacticalList', {});
                        self.$store.dispatch('getUsersTacticalList', [30, 1, self.users_keyword]);
                    }
                }, 650);
        },
        chooseUser(user) {
            this.user_selected = user;
            this.user = user.id;

            // set empty search user keyword
            this.users_keyword = '';
        },
        setEmptyUser() {
            this.user_selected = {};
            this.user = '';
            document.getElementById('find-user-input').focus();
        },
        getData() {

            this.name = '';
            this.device_id = '';
            this.user = '';
            this.description = '';
            
            this.users_keyword = '';
            this.user_selected = {};
            this.$store.commit('setUsersTacticalList', {});

            this.error_name = '';
            this.error_device_id = '';
            this.error_user = '';
            this.error_description = '';


            if (this.route_name === 'PageTacticalDevicesEdit') {
                // console.log(this.id);

                // for dispatch get data

                this.showLoading(true);

                this.$store.dispatch('getTacticalDevicesDetail', [this.id])
                .then((resp) => {
                    if (resp === 'success') {

                        this.showLoading(false);

                    } else {
                        this.error();
                    }
                });

            } else {
                if (this.route_name === 'PageTacticalDevicesCreate')
                    this.$store.commit('setTacticalDevicesDetail', {});
            }
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');

                if (result.isConfirmed) {
                    if (this.route_name === 'PageTacticalDeviceCreate') {
                        this.name = '';
                        this.device_id = '';
                        this.user = '';
                        this.description = '';

                        this.users_keyword = '';
                        this.user_selected = {};
                        this.$store.commit('setUsersTacticalList', {});

                        this.error_name = '';
                        this.error_device_id = '';
                        this.error_user = '';
                        this.error_description = '';
                    } else {
                        this.getData();
                    }
                }
            });
        },
        submit(e, save_continue=false){
            e.preventDefault();
            // console.log(e);

            this.showLoading(true);

            this.error_name = '';
            this.error_device_id = '';
            this.error_user = '';
            this.error_description = '';

            // validation
            if (this.name.length==0 || this.device_id.length==0) {

                this.error_name = (this.name.length==0 ? 'Field name is required.' : '');
                this.error_device_id = (this.device_id.length==0 ? 'Field device id (IMEI) is required.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Name & device id (IMEI) is required!',
                    // timer: 3000,
                });

                return;
            }

            if (this.name.length>255 || this.device_id.length>255) {

                this.error_name = (this.name.length>255 ? 'Field name is not more than 255 characters.' : '');
                this.error_device_id = (this.device_id.length>255 ? 'Field device id (IMEI) is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'Name & device id (IMEI) is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            // if (!Number.isInteger(parseInt(this.device_id)) || this.device_id.length < 15) {

            //     this.error_device_id = (!Number.isInteger(parseInt(this.device_id)) ? 'Field device id (IMEI) must numeric.' : '');

            //     if (this.device_id.length < 15)
            //         this.error_device_id = this.error_device_id + ' Field device id (IMEI) is minimal 15 characters.';

            //     this.$swal.fire({
            //         icon: 'warning',
            //         title: 'Data must numeric & length is min 15 characters!',
            //         text: 'Device id (IMEI) must numeric & length is min 15 characters!!',
            //         // timer: 3000,
            //     });

            //     return;
            // }

            // console.log([this.name, this.device_id, this.user, this.description]);
            // this.getData();

            if (this.route_name === 'PageTacticalDevicesCreate') {

                this.$store.dispatch('getTacticalDevicesCreate', [this.name, this.device_id, this.user, this.description])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageTacticalDevicesIndex' });
                        if (save_continue === false) {
                            this.$router.push('/tactical-devices');
                        } else {
                            this.$router.push('/tactical-devices/'+ resp.data.data.id +'/edit');
                        }

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully created!',
                            timer: 3000,
                        });
                    } else {
                        
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                            this.error_device_id = (resp.data.message.errors.device_id ? resp.data.message.errors.device_id : '');
                            this.error_user = (resp.data.message.errors.user ? resp.data.message.errors.user : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });

            // PageTacticalDevicesEdit
            } else {

                this.$store.dispatch('getTacticalDevicesUpdate', [this.id, this.name, this.device_id, this.user, this.description])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageTacticalDevicesIndex' });
                        if (save_continue === false)
                            this.$router.push('/tactical-devices');

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                    } else {

                        if (resp.data.message && resp.data.message.errors) {
                            this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                            this.error_device_id = (resp.data.message.errors.device_id ? resp.data.message.errors.device_id : '');
                            this.error_user = (resp.data.message.errors.user ? resp.data.message.errors.user : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style lang="sass">
    .choosen-user
        background-color: #2b404e
        top: 0
        left: 0
</style>
